import { useState } from 'react';
import Select from 'react-select';
import { branchNames } from '../../constants/enums/RefundContacts';
import classNames from 'classnames';
import loadingGif from '../../assets/Other/loading.gif';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import request from '../../utils/APIHelper/request';
import { toast } from 'react-toastify';

const ChangeContainerBranch = ({ swalModal }) => {
  const [container, setContainer] = useState('');
  const [parcelsNumber, setParcelsNumber] = useState('---');
  const [branchId, setBranhcId] = useState('1');
  const [loading, setLoading] = useState(false);
  const [numberLoading, setNumberLoading] = useState(false);

  const selectOptions = Object.keys(branchNames).map((item) => ({
    value: item,
    label: branchNames[item],
  }));

  const showSwal = (code, message) => {
    swalModal.fire({
      title: 'Can not change branch for container!',
      text: message,
      icon: code,
      showCancelButton: true,
      showConfirmButton: false,
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'bg-blue-800 text-white hover:bg-blue-900',
        cancelButton: 'bg-gray-300 text-gray-800 hover:bg-gray-400',
        popup: 'w-[400px] text-sm',
      },
    });
  };

  const changeBranch = async () => {
    if (container.length > 0 && branchId !== null && parcelsNumber > 0) {
      const result = await request({
        url: `${controllers.foxContainer}changeContainerBranch`,
        type: requestTypes.post,
        body: { container, branchId },
        setLoading,
      });
      if (result?.code === responseTypes.success) toast.info(result.message);
      else showSwal(result?.code, result.message);
    }
  };

  const checkParcelsNumberInContainer = async (e) => {
    if (e.target.value?.length !== 0) {
      const result = await request({
        url: `${controllers.foxContainer}getParcelsNumber`,
        type: requestTypes.post,
        params: { container: e.target.value },
        setLoading: setNumberLoading,
      });
      setParcelsNumber(result);
    } else {
      setParcelsNumber('---');
    }
  };

  return (
    <div className="px-4 sm:px-8 md:px-16">
      <div className="m-5 text-xl text-blue-800">CHANGE CONTAINER BRANCH</div>
      <div className="m-5 text-md text-blue-800">CONTAINER:</div>
      <div className="w-1/2 sm:w-3/4 md:w-[200px] flex mx-auto">
        <input
          onBlur={checkParcelsNumberInContainer}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.target.blur();
            }
          }}
          maxLength={15}
          value={container}
          onChange={(e) =>
            setContainer(e.target.value.replace(/[^a-zA-Z0-9-]/g, ''))
          }
          type="text"
          placeholder="Format - 9999A..."
          className="border-b-[1px] border-blue-800 px-4 mb-5 focus:outline-none focus:border-b-[1px] focus:border-blue-400 relative w-full"
        />
        <div className="text-xs bg-blue-900 flex text-white items-center max-h-[1.55rem] px-1 rounded-r-lg cursor-pointer">
          ENTER
        </div>
      </div>

      <div className="m-5 text-md text-blue-800 flex items-center justify-center">
        AMOUNT OF PARCELS:{' '}
        {!numberLoading ? (
          <span className="text-red-700 mx-1 font-semibold">
            {parcelsNumber}
          </span>
        ) : (
          <img className="w-4 h-4 inline-block mx-1" src={loadingGif} />
        )}
      </div>
      <div className="m-5 text-md text-blue-800">CHANGE TO BRANCH:</div>
      <Select
        value={selectOptions.find((option) => option.value === branchId)}
        onChange={(selectedOption) => setBranhcId(selectedOption.value)}
        options={selectOptions}
        className="w-full sm:w-3/4 md:w-[470px] mx-auto mb-10 text-center"
        classNamePrefix="custom-select"
        placeholder="Choose branch..."
      />
      <div
        onClick={changeBranch}
        className={classNames(
          'inline-block text-white px-10 rounded-xl',
          container.length > 0 && branchId !== null && parcelsNumber > 0
            ? 'bg-red-800 hover:bg-red-900 hover:transition-all hover:duration-300 cursor-pointer'
            : 'bg-gray-400',
          loading ? 'hidden' : null,
        )}
      >
        CHANGE BRANCH
      </div>
      <div
        className={classNames(
          'w-full flex justify-center items-center',
          !loading ? 'hidden' : null,
        )}
      >
        <img className="w-8 h-8" src={loadingGif} />
      </div>
      <div
        className={classNames('mt-5 text-gray-400', !loading ? 'hidden' : null)}
      >
        Please wait, processing large amount
        <br /> of data might take some time....
      </div>
    </div>
  );
};

export default ChangeContainerBranch;
